// extracted by mini-css-extract-plugin
export default {"icon_button":"NotificationsActionCell_icon_button__3wZjN","button":"NotificationsActionCell_button__nu2QU"};